import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./globals.css";
import { checkAppVersion, registerChunkErrorRecovery } from "./app-version";

// Log preload errors but don't auto-reload.
// Crash recovery is handled by the inline script in index.html.
window.addEventListener("vite:preloadError", (event) => {
  console.warn("[Vite] Preload error detected:", event);
});

checkAppVersion();
registerChunkErrorRecovery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
